export function formatNumberCeisa(value, withDecimal = true) {
  if (value == null || isNaN(value)) return withDecimal ? '0,00' : '0';
  return new Intl.NumberFormat('id-ID', {
    minimumFractionDigits: withDecimal ? 2 : 0,
    maximumFractionDigits: withDecimal ? 2 : 0,
  }).format(value);
}

export function formatCurrency(value) {
  if (value == null || isNaN(value)) return 0;
  return new Intl.NumberFormat('en', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatQty(value) {
  if (value == null || isNaN(value)) return 0;
  return new Intl.NumberFormat('en', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 6,
  }).format(value);
}

export function roundDecimal(value, decimals = 6) {
  const factor = 10 ** decimals;
  return Math.round((value + Number.EPSILON) * factor) / factor;
}